import React from 'react';
import { Layer, Line, Circle, Label, Tag, Text } from 'react-konva';
import { CELL_SIZE } from './GridLayer';

// Renders an active measurement line + distance label.
// Distance uses 5e Chebyshev: each square is 5 ft, diagonals count as 1.
// `from` and `to` are grid coords (integers). When either is null, renders nothing.

export default function MeasureLayer({ from, to, bare = false }) {
  if (!from || !to) return bare ? null : <Layer listening={false} />;

  const sx = (from.x + 0.5) * CELL_SIZE;
  const sy = (from.y + 0.5) * CELL_SIZE;
  const ex = (to.x   + 0.5) * CELL_SIZE;
  const ey = (to.y   + 0.5) * CELL_SIZE;

  const dx = Math.abs(to.x - from.x);
  const dy = Math.abs(to.y - from.y);
  const cells = Math.max(dx, dy);
  const feet  = cells * 5;

  // Label sits above the midpoint of the line.
  const mx = (sx + ex) / 2;
  const my = (sy + ey) / 2 - 24;

  const body = (
    <>
      <Line
        points={[sx, sy, ex, ey]}
        stroke="#facc15"
        strokeWidth={2}
        dash={[8, 4]}
        lineCap="round"
        shadowColor="rgba(0,0,0,0.85)"
        shadowBlur={4}
      />
      <Circle x={sx} y={sy} radius={5} fill="#facc15" stroke="#000" strokeWidth={1} />
      <Circle x={ex} y={ey} radius={5} fill="#facc15" stroke="#000" strokeWidth={1} />
      <Label x={mx} y={my}>
        <Tag
          fill="rgba(20,32,56,0.95)"
          stroke="#facc15"
          strokeWidth={1}
          cornerRadius={3}
          shadowColor="rgba(0,0,0,0.7)"
          shadowBlur={6}
        />
        <Text
          text={`${feet} ft · ${cells} sq`}
          padding={6}
          fontSize={13}
          fontStyle="bold"
          fill="#facc15"
          fontFamily="'Press Start 2P', monospace"
        />
      </Label>
    </>
  );

  if (bare) return body;
  return <Layer listening={false}>{body}</Layer>;
}
